import { create } from 'zustand'
import { BookmarkCategory } from '../api/bookmark'

interface PlaceBookmarkState {
  /** placeId → "내가 저장한 장소인가". 목록 응답보다 항상 최신이다. */
  saved: Record<string, boolean>
  setSaved: (placeId: string | number, isSaved: boolean) => void
  /**
   * 마지막으로 받아온 플레이트리스트 목록.
   *
   * 저장 시트를 열 때마다 getBookmarks()를 기다리면 매번 "불러오는 중"이 보인다.
   * 목록 자체는 자주 바뀌지 않으므로 캐시를 먼저 그리고, 응답이 오면 갈아끼운다.
   */
  categories: BookmarkCategory[] | null
  setCategories: (categories: BookmarkCategory[]) => void
  /** 로그아웃 시 호출. 안 지우면 다음 계정에 이전 사용자의 리스트가 잠깐 보인다. */
  reset: () => void
}

/**
 * 장소 저장 여부를 화면 간에 공유하는 저장소.
 *
 * 북마크 아이콘은 여러 곳에 동시에 떠 있다 — 같은 장소의 리뷰가 피드에 두 번
 * 나오기도 하고, 지도·검색·플레이트리스트에도 같은 장소가 있다. 각 버튼이
 * 자기 상태만 들고 있으면 한 곳에서 해제해도 나머지는 채워진 채로 남는다.
 * 목록을 다시 불러오기 전까지 어긋난 아이콘이 보이는 게 이 때문이다.
 *
 * 여기에 기록된 값이 API가 준 초기값보다 우선한다. 사용자가 방금 한 행동이
 * 목록을 받아온 시점보다 항상 나중이기 때문이다.
 */
export const usePlaceBookmarkStore = create<PlaceBookmarkState>((set) => ({
  saved: {},
  setSaved: (placeId, isSaved) =>
    set((state) => ({
      saved: { ...state.saved, [String(placeId)]: isSaved },
    })),
  categories: null,
  setCategories: (categories) => set({ categories }),
  reset: () => set({ saved: {}, categories: null }),
}))

/** 컴포넌트 밖(이벤트 핸들러 등)에서 쓰는 단축 호출 */
export const setPlaceSaved = (placeId: string | number, isSaved: boolean) =>
  usePlaceBookmarkStore.getState().setSaved(placeId, isSaved)
